import React from "react";
import { cx } from "./cx";

// Tabs — underline tab strip.
// tabs: [{ key, label, count? }], active: key, onChange(key).
//
// REFINEMENT NOTES:
// - focus-visible (keyboard-only); dropped the ring-offset that looked odd on an
//   underline tab — the ring now hugs the tab via rounded-t-btn.
// - count chip gets tabular-nums to match the rest of the mono numerics.
export function Tabs({ tabs = [], active, onChange, className = "" }) {
  return (
    <div className={cx("flex items-center gap-1 border-b border-border", className)} role="tablist">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(t.key)}
            className={cx(
              "inline-flex items-center gap-2 px-4 py-2.5 -mb-px text-sm font-medium border-b-2 transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-t-btn",
              isActive
                ? "border-primary text-primary"
                : "border-transparent text-body/70 hover:text-primary hover:border-border"
            )}
          >
            {t.label}
            {t.count !== undefined && (
              <span
                className={cx(
                  "rounded-md px-1.5 py-0.5 text-11 font-mono font-semibold tabular-nums",
                  isActive ? "bg-primary/10 text-primary" : "bg-border/60 text-body"
                )}
              >
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
